import { API_URL } from '../utils/config';
import React, { Component } from 'react';
import '../App.css';
import axios from 'axios';
import { Button, Modal, FormGroup, ControlLabel, FormControl } from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import {isLoggedIn } from '../utils/AuthService';

var DictListwy = React.createClass({

getInitialState: function() {

  return {
    addObject: {
      id: '',
      numerListwy: '',
      cenaZaMb: ''
    },
    data: null,
    selectedListwaId: null,
    showBulkModal: false,
    bulkPrefix: '',
    bulkPriceMin: '',
    bulkPriceMax: '',
    bulkMode: 'percent',
    bulkPercent: '',
    bulkAmount: '',
    bulkPreview: null,
    bulkLoading: false
  }
  },

  openBulkModal: function() {
    this.setState({
      showBulkModal: true,
      bulkPrefix: '',
      bulkPriceMin: '',
      bulkPriceMax: '',
      bulkMode: 'percent',
      bulkPercent: '',
      bulkAmount: '',
      bulkPreview: null
    });
  },

  closeBulkModal: function() {
    this.setState({ showBulkModal: false });
  },

  buildBulkBody: function() {
    return {
      prefix: this.state.bulkPrefix,
      priceMin: this.state.bulkPriceMin,
      priceMax: this.state.bulkPriceMax,
      mode: this.state.bulkMode,
      percent: this.state.bulkPercent,
      amount: this.state.bulkAmount
    };
  },

  loadBulkPreview: function() {
    var self = this;
    this.setState({ bulkLoading: true });
    axios.post(API_URL + '/dictListwy/bulkPreview', this.buildBulkBody())
      .then(function(res) { self.setState({ bulkPreview: res.data, bulkLoading: false }); })
      .catch(function(err) { console.log(err); self.setState({ bulkLoading: false }); alert('Błąd podglądu'); });
  },

  applyBulkUpdate: function() {
    var self = this;
    var isAmount = this.state.bulkMode === 'amount';
    var val = parseFloat(isAmount ? this.state.bulkAmount : this.state.bulkPercent);
    if (isNaN(val) || val === 0) { alert(isAmount ? 'Podaj kwotę różną od 0' : 'Podaj % różny od 0'); return; }
    if (!this.state.bulkPreview || this.state.bulkPreview.count === 0) { alert('Brak pasujących listew'); return; }
    var opis = isAmount
      ? (val > 0 ? 'o +' + val + ' zł' : 'o ' + val + ' zł')
      : 'o ' + val + '%';
    if (!window.confirm('Zmienisz ceny ' + this.state.bulkPreview.count + ' listew ' + opis + '. Kontynuować?')) return;
    axios.post(API_URL + '/dictListwy/bulkUpdate', this.buildBulkBody())
      .then(function(res) {
        alert('Zaktualizowano ' + res.data.updated + ' listew');
        self.setState({ showBulkModal: false });
        self.refreshTable();
      })
      .catch(function(err) { console.log(err); alert('Błąd aktualizacji'); });
  },

  renderBulkModal: function() {
    var preview = this.state.bulkPreview;
    var items = preview ? preview.items : [];
    var self = this;
    return (
      <Modal show={this.state.showBulkModal} onHide={this.closeBulkModal} bsSize="large">
        <Modal.Header closeButton>
          <Modal.Title>Masowa zmiana cen listew</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-sm-4">
              <FormGroup>
                <ControlLabel>Numer listwy zaczyna się od</ControlLabel>
                <FormControl type="text" placeholder="np. IN, 97, A1"
                  value={this.state.bulkPrefix}
                  onChange={function(e) { self.setState({ bulkPrefix: e.target.value, bulkPreview: null }); }} />
              </FormGroup>
            </div>
            <div className="col-sm-2">
              <FormGroup>
                <ControlLabel>Cena od (zł/mb)</ControlLabel>
                <FormControl type="text" placeholder="min"
                  value={this.state.bulkPriceMin}
                  onChange={function(e) { self.setState({ bulkPriceMin: e.target.value.replace(/,/g,'.'), bulkPreview: null }); }} />
              </FormGroup>
            </div>
            <div className="col-sm-2">
              <FormGroup>
                <ControlLabel>Cena do (zł/mb)</ControlLabel>
                <FormControl type="text" placeholder="max"
                  value={this.state.bulkPriceMax}
                  onChange={function(e) { self.setState({ bulkPriceMax: e.target.value.replace(/,/g,'.'), bulkPreview: null }); }} />
              </FormGroup>
            </div>
            <div className="col-sm-2">
              <FormGroup>
                <ControlLabel>Rodzaj zmiany</ControlLabel>
                <FormControl componentClass="select"
                  value={this.state.bulkMode}
                  onChange={function(e) { self.setState({ bulkMode: e.target.value, bulkPreview: null }); }}>
                  <option value="percent">procent (%)</option>
                  <option value="amount">kwota (zł)</option>
                </FormControl>
              </FormGroup>
            </div>
            {this.state.bulkMode === 'amount' ? (
              <div className="col-sm-2">
                <FormGroup>
                  <ControlLabel>Kwota zmiany (zł/mb)</ControlLabel>
                  <FormControl type="text" placeholder="np. 2 lub -1.50"
                    value={this.state.bulkAmount}
                    onChange={function(e) { self.setState({ bulkAmount: e.target.value.replace(/,/g,'.'), bulkPreview: null }); }} />
                </FormGroup>
              </div>
            ) : (
              <div className="col-sm-2">
                <FormGroup>
                  <ControlLabel>% zmiany</ControlLabel>
                  <FormControl type="text" placeholder="np. 5 lub -10"
                    value={this.state.bulkPercent}
                    onChange={function(e) { self.setState({ bulkPercent: e.target.value.replace(/,/g,'.'), bulkPreview: null }); }} />
                </FormGroup>
              </div>
            )}
          </div>
          <div className="row">
            <div className="col-sm-12" style={{marginTop:'5px'}}>
              <Button bsStyle="info" onClick={this.loadBulkPreview} disabled={this.state.bulkLoading}>
                {this.state.bulkLoading ? 'Liczę...' : 'Podgląd'}
              </Button>
            </div>
          </div>
          {preview ? (
            <div style={{marginTop:'15px'}}>
              <strong>Pasujących listew: {preview.count}</strong>
              {preview.count > 500 ? <span style={{color:'#888'}}> (pokazuję pierwsze 500)</span> : null}
              <div style={{maxHeight:'320px',overflowY:'auto',border:'1px solid #ddd',marginTop:'8px'}}>
                <table className="table table-striped" style={{marginBottom:0}}>
                  <thead><tr><th>Numer</th><th>Stara cena</th><th>Nowa cena</th></tr></thead>
                  <tbody>
                    {items.map(function(it) {
                      return (
                        <tr key={it.id}>
                          <td>{it.numerListwy}</td>
                          <td>{it.cenaStara.toFixed(2)}</td>
                          <td><strong>{it.cenaNowa.toFixed(2)}</strong></td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          ) : null}
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={this.closeBulkModal}>Anuluj</Button>
          <Button bsStyle="danger" onClick={this.applyBulkUpdate} disabled={!preview || preview.count === 0}>
            Zmień ceny {preview ? '(' + preview.count + ')' : ''}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  },

  onRowSelect: function(row, isSelected) {
		if(isSelected) {
			this.setState({ selectedListwaId: row.id });
		}else {
			this.setState({ selectedListwaId: null });
		}
	},

  onDeleteBtnClicked: function() {
    axios.delete(API_URL + '/dictListwy/' + this.state.selectedListwaId)
      .then(function (response) {
        this.refreshTable();
      }.bind(this))
      .catch(function (error) {
        console.log(error);
      });
  },

  refreshTable: function() {
    axios.get(API_URL + '/dictListwy')
    .then(function (dictListwy) {
      this.setState({data: dictListwy.data});
    }.bind(this));
  },

  getListwyById: function(id) {
    for(var i in this.state.data) {
      if(this.state.data[i].id === id) {
        return this.state.data[i];
      }
    }
    return '';
  },

  render: function() {
    var selectRowProp = {
			mode: "radio",
			clickToSelect: true,
			className: "selected-row",
			bgColor: 'rgb(101, 148, 255)',
			onSelect: this.onRowSelect
		};

    if(!isLoggedIn()){
			return (<div></div>);
		};

  return (
    <div>

	<div className="form-group">

		<div className="row">
			<div className="col-sm-4">
				<div className="row">
					<div className="col-sm-4">
						<label htmlFor="numerListwy">Numer Listwy: </label>
					</div>
					<div className="col-sm-8">
            <FormControl
              type="text"
              placeholder="Numer Listwy"
              value={this.state.addObject.numerListwy}
              onChange={this.onAddDictListwaNumerChange} />
					</div>
				</div>
			</div>
			<div className="col-sm-8">
      </div>
		</div>
		<div className="row">
			<div className="col-sm-4">
				<div className="row">
					<div className="col-sm-4">
						<label htmlFor="cenaZaMb">Cena za mb: </label>
					</div>
					<div className="col-sm-8">
          <FormControl
            type="text"
            placeholder="Cena za MB"
            value={this.state.addObject.cenaZaMb}
            onChange={this.onAddDictListwaCenaZaMBChange} />
					</div>
				</div>
			</div>
			<div className="col-sm-8"/>
		</div>

	</div>

  <div>
  <Button bsStyle="primary" onClick={this.onAddBtnClicked}>Dodaj Listwę</Button>
  {' '}
  <Button bsStyle="warning" onClick={this.openBulkModal}>Masowa zmiana cen</Button>
  </div>
  {this.renderBulkModal()}
    <br/>
  <BootstrapTable data={this.state.data}
          striped={true}
          hover={true}
          pagination={true}
          search={true}
          selectRow={selectRowProp}>
    <TableHeaderColumn dataField="id" isKey={true} dataSort={true}>ID</TableHeaderColumn>
    <TableHeaderColumn dataField="numerListwy" dataSort={true}>Numer Listwy</TableHeaderColumn>
    <TableHeaderColumn dataField="cenaZaMb">Cena za MB</TableHeaderColumn>
  </BootstrapTable>

<br/>
<div>
<Button bsStyle="danger" onClick={this.onDeleteBtnClicked}>Usuń Listwę</Button>
</div>

</div>
);
},

componentDidMount: function() {
  this.refreshTable();
},

clearAddObject: function() {
  this.state.addObject.id = null;
  this.state.addObject.numerListwy = '';
  this.state.addObject.cenaZaMb = '';
},

onAddDictListwaNumerChange: function(event) {
  this.state.addObject.numerListwy = event.target.value;
  this.forceUpdate();
},

onAddDictListwaCenaZaMBChange: function(event) {
  this.state.addObject.cenaZaMb = event.target.value.replace(/,/g, '.');
  this.forceUpdate();
},

onAddBtnClicked: function() {
  axios.post(API_URL + '/dictListwy/', this.state.addObject)
    .then(function (response) {
      this.refreshTable();
    }.bind(this))
    .catch(function (error) {
      alert("Błędnie wprowadzone dane");
      console.log(error);
    });

    this.setState({
      addObject: {
        id: '',
        numerListwy: '',
        cenaZaMb: ''
      }
    });
}
});

export default DictListwy;



// WEBPACK FOOTER //
// ./src/components/DictListwy.js